module.exports = "/assets/data/efee62d5b4b0479d7719ab993f941fe6-LS14.data.json";